import { render, staticRenderFns } from "./VacancyDepartmentInfo.vue?vue&type=template&id=66164e65"
import script from "./VacancyDepartmentInfo.vue?vue&type=script&lang=js"
export * from "./VacancyDepartmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports